// src/components/Robotics.js
import React from 'react';

const Robotics = () => {
    return <div className="text-balance font-black font-sans">
    WIP. Come back soon!
  </div>;};

export default Robotics;
